import morphism, { StrictSchema } from 'morphism'

import ServerPassengerInterface from '../../interfaces/server/Passenger'
import ClientSSRInterface from '../../interfaces/client/SSR'
import ServerPassengerSSRInterface from '../../interfaces/server/PassengerSSR'
import ClientInfantPassengerInterface from '../../interfaces/client/InfantPassenger'
import ServerPassengerFlightDetailInterface from '../../interfaces/server/PassengerFlightDetail'
import ServerInfantPassengerInterface from '../../interfaces/server/InfantPassenger'

import constants from '../../config/constants'

import { dateFromBackEndToFrontendFormat } from '../../utils/dates'

import passengerSSR from './passengerSSR'
import infantPassengerSchema from './infantPassenger'

export const dateOfBirth = (passenger: ServerPassengerInterface) =>
  dateFromBackEndToFrontendFormat(passenger.dateOfBirth)

export const SSRs = ({ ssrs = [] }: ServerPassengerInterface) => {
  if (!ssrs || !ssrs.length) return []

  const SSRsWithoutLuggage = ssrs.filter(
    (SSR: ServerPassengerSSRInterface) =>
      !SSR.id.includes(constants.luggagePrefix)
  )

  return SSRsWithoutLuggage.map((ssr: ServerPassengerSSRInterface) =>
    morphism<StrictSchema<ClientSSRInterface, ServerPassengerSSRInterface>>(
      passengerSSR,
      ssr
    )
  )
}
  
export const infant = (passenger: ServerPassengerInterface) => {
  if (!passenger.infant) return undefined

  return morphism<
    StrictSchema<ClientInfantPassengerInterface, ServerInfantPassengerInterface>
  >(infantPassengerSchema, passenger.infant)
}

export const luggage = ({ ssrs = [] }: ServerPassengerInterface) => {
  const getLuggage = (ssr: ServerPassengerSSRInterface) =>
    ssr.id.includes(constants.luggagePrefix)

  const luggageSSR = (ssrs !== null && ssrs.find(getLuggage)) ? ssrs.find(getLuggage) as ServerPassengerSSRInterface : { id: undefined }
  return luggageSSR?.id
}

export const checkedInOnFlights = ({
  flightDetails = [],
}: ServerPassengerInterface) =>
flightDetails ? flightDetails
    .filter(
      (flightDetail: ServerPassengerFlightDetailInterface) =>
        flightDetail.liftStatus === 'CheckedIn'
    )
    .map(
      (flightDetail: ServerPassengerFlightDetailInterface) =>
        flightDetail.flightId
    ) : []

export default {
  id: 'id',
  thirdPartyBookingNumber: 'thirdPartyBookingNumber',
  transaviaBookingNumber: 'transaviaBookingNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  dateOfBirth,
  gender: 'gender',
  travelClass: 'travelClass',
  ssrs: SSRs,
  luggage,
  infant,
  checkedInOnFlights,
}
